import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import divisionServices from './division.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getDivision = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DIVISION,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(iType === 1 ? `/api/app/Formal_Division/`: `/api/app/Funcional_Division/`, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await divisionServices.getDivisions(params, iType);
    dispatch({
      type: actions.GET_DIVISION,
      payload: {
        division: resp.data.data,
        divisionLength: resp.data.count
      }
    });
    dispatch({
      type: actions.DIVISION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.DIVISION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_DIVISION,
      payload: false
    });
  }
}

export const saveDivision = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_DIVISION_LOADER,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Division/' : '/api/app/Funcional_Division/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await divisionServices.saveDivision(req, iType);
    const { division, divisionLength } = getState().division;
    const aDivision = [...division, resp.data];
    dispatch({
      type: actions.GET_DIVISION,
      payload: {
        division: aDivision,
        divisionLength: divisionLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_DIVISION_LOADER,
      payload: false
    });
  }
}

export const editDivision = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_DIVISION_LOADER,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Division/${id}/` : `/api/app/Funcional_Division/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await divisionServices.editDivision(id, req, iType);
    const { division, divisionLength } = getState().division;
    division[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_DIVISION,
      payload: {
        division: division,
        divisionLength: divisionLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_DIVISION_LOADER,
      payload: false
    });
  }
}

export const deleteDivision = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DIVISION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 0 ? `/api/app/Formal_Division/${id}/` : `/api/app/Funcional_Division/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await divisionServices.deleteDivision(id, iType);
    const { division, divisionLength } = getState().division;
    division.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_DIVISION,
      payload: {
        division: division,
        divisionLength: divisionLength -1
      }
    });
    dispatch({
      type: actions.DIVISION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.DIVISION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_DIVISION,
      payload: false
    });
  }
}